import { makeStyles } from "@mui/styles";
import {Theme} from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  backgroundColorOffCollapse: {
    backgroundColor: `${theme.palette.white.main}`,
    borderRadius: "4px",
  },
  backgroundColorOnCollapse: {
    backgroundColor: `${theme.palette.white.main}`,
    borderRadius: "unset",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
}));

export default useStyles;
